import type { Facets } from '@iheartjane/dm-sdk';
import type { Nullable } from '@iheartjane/types';

const storageNamespace = 'janePremium/filters';

export const get = (): Nullable<Facets> => {
  const stored = window.localStorage.getItem(storageNamespace);
  if (!stored) return null;

  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const set = (value: Facets) => {
  return window.localStorage.setItem(storageNamespace, JSON.stringify(value));
};

export const reset = () => {
  return window.localStorage.removeItem(storageNamespace);
};
